import { render, staticRenderFns } from "./ModalDetalhesLicenciada.vue?vue&type=template&id=4e4fb4bc&scoped=true&"
import script from "./ModalDetalhesLicenciada.vue?vue&type=script&lang=js&"
export * from "./ModalDetalhesLicenciada.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetalhesLicenciada.vue?vue&type=style&index=0&id=4e4fb4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4fb4bc",
  null
  
)

export default component.exports